module.exports = require("timers");


//////////////////
// WEBPACK FOOTER
// external "timers"
// module id = 310
// module chunks = 0